export const selectValue = (state, key) => state[key];
